import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import AppContext from "../../context/app/context";
import {useNavigate} from "react-router-dom";
import CategoryCharityContext from "../../context/category-charity/context";
import {useIsMount} from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import CategoryCharityTable from "../../components/category-charity/category-charity-table";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import {Button, Divider} from "antd";
import Can from "../../utils/rbac/can";
import {CAN_VIEW_HOME_PAGE} from "../../utils/rbac/permissions";
import {PlusOutlined} from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import SearchFilterCard from "../../components/general/filter-card";
import CategoryCharityContextProvider from "../../context/category-charity/provider";

interface IProps {
    children?: React.ReactNode;
}

const CategoryCharity: React.FC<IProps> = (props) => {
    const {t} = useTranslation();
    const {direction} = useContext(AppContext);
    const navigate = useNavigate();

    const [search, setSearch] = useState<string | undefined>(undefined);

    const {actions, loading, query} = useContext(CategoryCharityContext);

    useEffect(() => {
        actions.setSearch(search);
    }, [search]);

    const isMounted = useIsMount();
    useEffect(() => {
        !isMounted && actions.getData();
    }, [query, direction]);

    return (
        <div dir={direction} className={styles.container}>
            <PageHeader
                title={t("categories_charities")}
                extra={[
                    <RefreshBtn
                        key={0}
                        loading={loading.includes("list")}
                        onClick={() => actions.getData()}
                    >
                        {t("refresh")}
                    </RefreshBtn>,
                    <Divider key={1} type="vertical"/>,
                    <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
                        <Button
                            type="primary"
                            onClick={() => {
                                navigate(`/categories_charities/create`);
                            }}
                            icon={<PlusOutlined/>}
                        >
                            {t("add_category_charities")}
                        </Button>
                    </Can>,
                ]}
            />
            <SearchFilterCard
                formId="category-charity-filter"
                searchValue={search}
                setSearchValue={setSearch}
                onReset={() => {
                    actions.setQuery({
                        page: query?.page,
                        perPage: query?.perPage,
                    });
                }}
                resetLoading={loading.includes("list")}
                applyLoading={loading.includes("list")}
            >
            </SearchFilterCard>
            <CategoryCharityTable/>
        </div>
    )
}

const CategoryCharityPage = () => {
    return (
        <CategoryCharityContextProvider>
            <CategoryCharity/>
        </CategoryCharityContextProvider>
    );
};
export default CategoryCharityPage;